import React, { useEffect, useState } from "react";
import { Crud_Catalogos } from '../../../../herramientas/Crud_Catalogos';
import { timeToDateNumbers } from "../../../../herramientas/DateFormat";
import { confirmAlert } from 'react-confirm-alert';
import { TablePageable } from "../../../../Helpers";
import { CSVLink } from "react-csv";
import moment from "moment";

var user = JSON.parse(sessionStorage.getItem('usuario'));
var currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

const columnas = [
  { columna: "idMovimiento", label: "Id Movimiento" },
  {
    columna: "creationDate",
    label: "Fecha de creación",
    valor: (e) => e.creationDate ? moment(e.creationDate).format("YYYY-MM-DD HH:mm:ss") : "",
  },
  {
    columna: "cita",
    label: "Cita",
    valor: (e) => e.cita ? moment(e.cita).format("YYYY-MM-DD HH:mm:ss") : "",
  },
  {
    columna: "idOperacionEstatus",
    label: "Estatus operación",
    valor: (e) => e.idOperacionEstatus === 1 ? "SIN GPS" : e.idOperacionEstatus === 2 ? "EN RUTA" : "",
  },
  {
    columna: "gps",
    label: "GPS",
    valor: (e) => e.gps ? e.gps : e.esfull ? "full con: " + e.esfull : e.programado ? "programado" : "",
  },
  { columna: "contenedor", label: "Contenedor" },
  { columna: "booking", label: "Booking" },
  { columna: "cliente", label: "Cliente" },
  { columna: "transportista", label: "Transportista" },
  { columna: "corredor", label: "Corredor" },
  { columna: "localidad", label: "Localidad" },
];

let movimientoIds = [];

const SeguimientoNavieras = ({ SeguimientoNavierasContar, idPlataforma }) => {
  const [movimientos, setMovimientos] = useState([]);

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cargar = () => {
    if (!idPlataforma) {
      setMovimientos([]);
      return;
    }
    // Elegir variante (corredores vs localidades) igual que MovimientoGpsForm: perfil.movimientosBy === 4
    let usaLocalidades = false;
    if (Array.isArray(currentUser)) {
      for (let item of currentUser) {
        if (item.plataforma && item.plataforma.id === parseInt(idPlataforma)) {
          if (item.perfil && item.perfil.movimientosBy === 4) {
            usaLocalidades = true;
          }
          break;
        }
      }
    }
    const endpoint = usaLocalidades
      ? "seguimiento_navieras/movimientos_sin_check_localidades/plataforma/" + idPlataforma + "/" + user.id
      : "seguimiento_navieras/movimientos_sin_check/plataforma/" + idPlataforma + "/" + user.id;
    getfuntion("get", "", "", endpoint, "movimientos");
  };

  const getfuntion = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
      switch (metodo) {
        case "get":
          if (stateVar === "movimientos" && returnVal) {
            setMovimientos(returnVal);
          }
          break;
        case "put":
          if (stateVar === "check") {
            if (SeguimientoNavierasContar) {
              SeguimientoNavierasContar();
            }
            cargar();
          }
          break;
        default:
          break;
      }
    }).catch(err => {
      if (err.response) { console.log(err.response); } else { console.log("Error desconocido ...." + err); }
    });
  };

  const getValor = (valor, nombre) => {
    const col = columnas.find(c => c.columna === nombre);
    if (col && col.valor) {
      return col.valor(valor);
    }
    return valor[nombre] != null ? valor[nombre] : "";
  };

  const getDataToCsv = () => {
    let csvDataTemp = [];
    movimientoIds = [];
    if (columnas.length) {
      let columnasTemp = [];
      for (let c of columnas) {
        columnasTemp.push(c.label);
      }
      csvDataTemp.push(columnasTemp);
      for (let i of movimientos.filter(m => m.idMovimiento !== null)) {
        let columnasDataTemp = [];
        for (let c of columnas) {
          columnasDataTemp.push(getValor(i, c.columna));
        }
        csvDataTemp.push(columnasDataTemp);
        if (i.idMovimiento) {
          movimientoIds.push(i.idMovimiento);
        }
      }
    }
    return csvDataTemp;
  };

  const fresh = () => {
    setMovimientos([]);
    cargar();
  };

  return (
    <div className="mt-1">
      <TablePageable
        titulo={
          <div>
            <h3 className="float-left"> Seguimiento de movimientos sin GPS </h3>
            <span className="float-left ml-3">
              <CSVLink
                data={getDataToCsv()}
                filename={"Seguimiento-" + timeToDateNumbers(new Date().getTime()) + ".csv"}
                onClick={() => {
                  confirmAlert({
                    title: 'Atención',
                    message: '¿Quiere descargar y marcar seguimiento de estos movimientos ?',
                    buttons: [
                      {
                        label: 'Marcar seguimiento',
                        onClick: () => {
                          getfuntion("put", movimientoIds, "", "seguimiento_navieras/check", "check");
                        }
                      },
                      {
                        label: 'Solo descargar',
                        onClick: () => { return false; }
                      }
                    ]
                  });
                }}
              >
                <i className="fa fa-cloud-download" style={{ fontSize: "24px" }}> Check</i>
              </CSVLink>
            </span>
            <span className="float-left ml-3">
              <i
                className="fa fa-refresh"
                style={{ fontSize: "24px" }}
                onClick={() => { fresh(); }}
              ></i>
            </span>
          </div>
        }
        lista={movimientos}
        columnas={columnas}
        id="idMovimiento"
        csvname="Seguimiento"
        paginacion={true}
        elementosPorPagina={15}
        resaltarFuncion={(e) =>
          e.gps ||
          e.programado ||
          (e.cita && new Date(e.cita).getTime() < new Date().getTime())
        }
        resaltarColor={(e) => {
          return e.gps
            ? 'rgba(95, 231, 50, 0.30)'
            : e.programado
            ? 'rgba(38, 229, 242, 0.3)'
            : (e.cita && new Date(e.cita).getTime() > new Date().getTime())
            ? 'rgba(255, 255, 255, 0.30)'
            : 'rgba(255, 55, 55, 0.30)';
        }}
      />
    </div>
  );
};

export default SeguimientoNavieras;
